import { render, staticRenderFns } from "./auth-re-password.vue?vue&type=template&id=53d2b114&"
import script from "./auth-re-password.vue?vue&type=script&lang=js&"
export * from "./auth-re-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports